import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App'
import Help from './routes/public/Help'
import { AuthProvider } from './lib/auth'
import { LocaleProvider } from './lib/i18n'
import './styles/base.css'

/**
 * ⚠ THE UNLOCKED DOOR RENDERS OUTSIDE <AuthProvider>, AND THE PLACEMENT IS THE LAW
 * (PARATEXT.md §1: *"opening it tells no one"*).
 *
 * The provider fetches `/api/me` when it mounts, so anything rendered underneath it — however
 * early it branches — has already told the server that somebody arrived. Measured while
 * building this: three requests on opening the crisis page, from a branch that looked early
 * enough and was not. A person reaching for helplines must not cause a server to hear about
 * it, and **"no analytics" is a weaker promise than "no request"**.
 *
 * So the branch is here, above the provider, before anything asks who anyone is. The page needs
 * only the locale (localStorage, no network) and no router at all.
 */
const unlockedDoor = window.location.pathname === '/help'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    {unlockedDoor ? (
      <LocaleProvider>
        <Help />
      </LocaleProvider>
    ) : (
      <BrowserRouter>
        <AuthProvider>
          <App />
        </AuthProvider>
      </BrowserRouter>
    )}
  </StrictMode>,
)
